<template>
  <div class="tab">
    <div class="tab-item" :class="{'active': currentTab === index}"
         v-for="(item, index) in tabList" :key="index" @click="changeTab(item, index)">
      {{item.label}}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tab',
    props: {
      tabList: {
        type: Array,
        default: () => []
      },
      currentTab: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
      }
    },
    mounted () {
    },
    computed: {},
    watch: {},
    components: {},
    methods: {
      changeTab (item, index) {
        this.$emit('changeTab', item, index)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/global/variable";
  .tab {
    width: 100%;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    .tab-item {
      flex: 1;
      color: $color-light-gray;
      display: flex;
      /*justify-content: center;*/
      flex-direction: column;
      align-items: center;
      font-size: 15px;
    }
    .active {
      color: $color-title;
      &:after {
        content: '';
        display: inline-block;
        width: 18px;
        height: 2px;
        background-color: $color-theme;
        margin-top: 14px;
        border-radius: 1px;
      }
    }
  }
</style>
